/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
// import { FaRegFileAlt } from 'react-icons/fa';
// import { BsPlayBtn } from 'react-icons/bs';
// import subCategoryIcon from '../../../../../../../../assets/SvgIcons/resources/subCategory.svg';
// import resourceMic from '../../../../../../../../assets/SvgIcons/resources/Categoryrecorder.svg';
import { useLocation, useParams } from 'react-router-dom';
import useResourceHelper from '../../Reusable/ContentCards/useResourceHelper';

const CategoryBanner = () =>
{
	const location = useLocation(); // Get location object to access state
	const { categoryId } = useParams(); // Get categoryId from URL params as fallback
	const urlCategoryData = location.state?.categoryData as any;
	const { getRandomBackgroundImage } = useResourceHelper();

	// Add fallback state for when navigation state is missing
	const [ categoryData, setCategoryData ] = useState<any>(urlCategoryData);

	useEffect(() =>
	{
		if (urlCategoryData)
		{
			setCategoryData(urlCategoryData);
		}
	}, [ urlCategoryData, categoryId ]);

	const [ imageError, setImageError ] = useState(false);

	const getImageSource = () =>
	{
		// For podcasts (activeTab === 2), always use random background if no thumbnail
		if (!categoryData?.thumbnailUrl || imageError)
		{
			return getRandomBackgroundImage;
		}

		if (imageError) return getRandomBackgroundImage;

		if (categoryData?.thumbnailUrl) return categoryData?.thumbnailUrl;

		return getRandomBackgroundImage;
	};

	// Extract counts from categoryData with fallback to 0 - commented out as content counts are hidden
	// const subcategoriesCount = categoryData?.subcategoryCount || categoryData?.subcategoryCount || categoryData?.subcategories?.length || 0;
	// const articlesCount = categoryData?.contentCount?.articles || 0;
	// const videosCount = categoryData?.contentCount?.videos || 0;
	// const podcastsCount = categoryData?.contentCount?.podcasts || 0;
	// const documentsCount = categoryData?.contentCount?.documents || 0;

	// const list = [
	// 	{
	// 		icon     : subCategoryIcon,
	// 		count    : `${subcategoriesCount} `,
	// 		icontrue : false
	// 	},
	// 	{
	// 		icon     : '/images/icons/ArticleContent.svg',
	// 		count    : `${articlesCount} `,
	// 		icontrue : false

	// 	},
	// 	{
	// 		icon     : <BsPlayBtn fontSize={16} color={'rgb(145 148 151)'} />,
	// 		count    : `${videosCount} `,
	// 		icontrue : true

	// 	},
	// 	{
	// 		icon     : resourceMic,
	// 		count    : `${podcastsCount} `,
	// 		icontrue : false

	// 	},
	// 	{
	// 		icon     : <FaRegFileAlt fontSize={14} color={'rgb(145 148 151)'} />,
	// 		count    : `${documentsCount} `,
	// 		icontrue : true

	// 	} ];

	if (!categoryData)
	{
		return (
			<Grid container sx={{ backgroundColor: 'var(--baseColor)', borderRadius: '16px' }} p={2} mb='24px'>
				<Grid item xs>
					<Box display='flex' justifyContent='center' alignItems='center' height='200px'>
						<Typography color='textSecondary'>No category data available</Typography>
					</Box>
				</Grid>
			</Grid>
		);
	}

	return (
		<Grid container sx={{ backgroundColor: 'var(--baseColor)', borderRadius: '16px' }} p={2} mb='24px'>
			<Grid item xs pr={1}>
				<Stack flexDirection='column' height='100%' justifyContent='space-between'>
					<Box display='flex' flexDirection='column'>
						<Typography fontSize={24} fontWeight={600}>
							{categoryData?.title || categoryData?.name || ''}
						</Typography>
						<Typography color={'rgba(96, 97, 98, 1)'} pt={1}
							sx={{
								display         : '-webkit-box',
								WebkitBoxOrient : 'vertical',
								WebkitLineClamp : 3,
								overflow        : 'hidden',
								textOverflow    : 'ellipsis'
							}}
						>
							{categoryData?.description || ''}
						</Typography>
					</Box>
					{/* Content counts section - commented out */}
					{/* <Stack flexDirection='row' gap={2} pt={3} alignItems={'center'}>
						{list.map((item, index) => (
							<>
								<Box flexDirection={'row'} display={'flex'} gap={'6px'} alignItems={'center'}>
									{item?.icontrue
										? (
											item?.icon
										)
										: (
											<Box width={14} height={14}>
												<img src={`${item?.icon}`} alt='img' style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
											</Box>
										)}

									<Typography fontSize={14} color={'#606162'}>{item.count} </Typography>
								</Box>
								{index < list.length - 1 && (
									<Divider orientation='vertical' flexItem sx={{ borderColor: '#bec2c5' }} />
								)}
							</>
						))}
					</Stack> */}
				</Stack>
			</Grid>
			<Grid item>
				<Box component='img' src={getImageSource()}
					width={'300px'} height={'100%'}
					onError={() => setImageError(true)}
					sx={{ borderRadius: '8px', aspectRatio: '16 / 9', objectFit: 'cover' }}
				/>
			</Grid>
		</Grid>
	);
};

export default CategoryBanner;